<template>
  <div class="data-item-box--inner">

    <h3 class="header-box">
      <span style="border-left: 3px solid rgb(108, 240, 245);padding-left: 5px">
        {{ currentRobot.code }}
      </span>
      <span style="border-left: none; margin-left: 10px;">{{ langMap.robot[lang] }}</span>
    </h3>

    <div class="data-var-box" ref="dataRef">
      <Card :bordered="false" class="move-data-box card-el">
        <div class="move-title">MOVEMENT DATA</div>
        <ul class="ul-box scrollbar-g move--scroll">
          <li class="move-item ul-item" v-for="(item, ix) in robot.move" :key="item.id">
            <!-- <label class="item-label">{{ item.name }}:</label>{{ item.value }} -->
            <span>
              >>{{ formatTime(item.gpsdatetime) }} MOVE
              {{ item.var1 }},{{ item.var2 }} {{ item.speed }}m/s {{ item.direction }}
            </span>
          </li>
          <li class="empty-data-box" v-show="!robot.move || !robot.move.length"><span>{{ langMap.empty[lang] }}</span></li>
        </ul>
      </Card>

      <div class="data-right-box">
        <div class="right-top-box">

          <!--状态数据块-->
          <Card :bordered="false" class="state-data-box card-el">
            <div class="status-title">SYSTEM STATUS</div>
            <ul class="ul-box scrollbar-g" :class="{'big-size': isBig }">
              <li class="state-item ul-item" v-for="(item, ix) in robot.status" :key="item.id">
                <span class="item-label">{{ item.name }}:</span><span class="item-value">{{ item.value | loseVal }}</span>
              </li>
              <li class="empty-data-box" v-show="!robot.status || !Object.keys(robot.status).length"><span>{{ langMap.empty[lang] }}</span>
              </li>
            </ul>
          </Card>
        </div>
      </div>

    </div>
    <!--弹框-->
    <!-- <div class="modal-container" v-show="showImg"
      :class="{ 'bg-open-animation': showImg, 'bg-close-animation': closeAction }">
      <div class="modal-body" :class="{ 'modal-open-animation': showImg, 'modal-close-animation': closeAction }">
        <div class="modal-box">
          <img :src="robot.img" />
        </div>
        <div class="close-icon" @click="closeModal">关闭</div>
      </div>
    </div> -->
    <Modal v-model="showImg" width="900" :title="langMap.image[lang]">
      <div class="modal-box scrollbar-g">
        <img :src="robot.time.img" />
      </div>
      <div slot="footer"></div>
    </Modal>
    
    <!-- 行为拒止弹窗组件 -->
    <BehaviorProhibitionModal
      :visible.sync="behaviorProhibitionModalVisible"
      :data="behaviorProhibitionData"
      :robot-code="String((currentBehaviorProhibitionData && currentBehaviorProhibitionData.code) || currentRobot.code || robot.code || robot.id || '')"
      :timestamp="String((currentBehaviorProhibitionData && currentBehaviorProhibitionData.timestamp) || (robot.time && robot.time.timestamp) || '')"
      @success="onBehaviorProhibitionSuccess"
      @error="onBehaviorProhibitionError"
      @cancel="onBehaviorProhibitionCancel"
    />
    
    <!-- 音频播放弹窗组件 -->
    <AudioPlayerModal
      :visible="audioPlayerModalVisible"
      :robotInfo="audioPlayerRobotInfo"
      @close="closeAudioPlayerModal"
    />
    
    <!-- 语音对讲弹窗组件 -->
    <IntercomModal
      :visible="intercomModalVisible"
      :robotInfo="intercomRobotInfo"
      @close="closeIntercomModal"
    />
  </div>
</template>
<script>
import api from "@/api";
import * as timeUtil from "@/utils/dateTimeUtil.js";
import Recorder from "js-audio-recorder";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import BehaviorProhibitionModal from '@/components/BehaviorProhibitionModal';
import AudioPlayerModal from '@/components/AudioPlayerModal';
import IntercomModal from '@/components/IntercomModal';
let scrollCount = 0;

export default {
  components: { BehaviorProhibitionModal, AudioPlayerModal, IntercomModal },
  props: {
    robot: {
      type: Object,
      default: () => {return {status: []} }
    },
    messageType: {
      type: String,
      default: ''
    },
    robotNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      langMap:langMap,
      recorder: new Recorder({
        sampleBits: 8,
        sampleRate: 8000,
        numChannels: 1
      }),
      showImg: false,
      closeAction: false,
      timer: null,
      time: '',
      currentRobot: {},
      isPausing: true, // 录音是否暂停状态
      icon: "ios-play-outline",
      playTime: 0,
      timer: null,
      src: null,
      cording: false, // 录制状态
      reseting: false, // 重置状态
      
      // 行为拒止相关
      behaviorProhibitionModalVisible: false,
      behaviorProhibitionData: {},
      currentBehaviorProhibitionData: null,
      
      // 音频播放弹窗相关
      audioPlayerModalVisible: false,
      audioPlayerRobotInfo: {},
      
      // 语音对讲弹窗相关
      intercomModalVisible: false,
      intercomRobotInfo: {},
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    // 是否满足单个机器人，且屏幕较大的情况
    isBig() {
      const q = window.innerWidth < 1450 || this.robotNum > 1 ? false : true;
      return q;
    }
  },
  filters: {
    // 过滤 'unknown', undefined, null
    loseVal(val) {
      if (['unknown', undefined, null].includes(val)) return '';
      else return val;
    }
  },
  methods: {
    blobToBase64(blob) {
      const fs = new FileReader();
      return new Promise((resolve, reject) => {
        fs.onload = e => {
          resolve(e.target.result);
        };
        fs.onerror = reject;
        fs.readAsDataURL(blob);
      });
    },
    // 上传录音
    async uploadRecord() {
      if (this.recorder == null || this.recorder.duration === 0) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.pleaseRecordFirst[this.lang]
        });
        return;
      }
      this.cording = false;
      this.recorder.pause(); // 暂停录音
      this.timer = null;

      let robotId = this.robot.id;
      let timestamp = this.robot.time.timestamp;
      let type = "wav";

      let formData = new FormData();
      let file = this.recorder.getWAVBlob(); // 获取wav格式音频数据
      let newFile = new Blob([file], { type: "audio/wav" });
      let fileOfBlob = new File([newFile], new Date().getTime() + ".wav");
      formData.append("file", fileOfBlob);
      let info = {
        base64: await this.blobToBase64(fileOfBlob), // 录音文件转成 base64
        type: type,
        suffixName: "wav",
        data: {
          robotId: robotId,
          timestamp: timestamp
        }
      };
      api.postData("notice-server/file/upload/voice", info, this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.$Notice.success({
            title: langMap.success[this.lang],
            desc: res.message
          });
        }
      });
    },
    handlePlay() {
      this.icon = "ios-pause-outline";
      this.isPausing = false;
      this.recorder.play();
      // 播放时长
      this.timer = setInterval(() => {
        try {
          this.playTime = this.recorder.getPlayTime();
        } catch (error) {
          this.timer = null;
        }
      }, 100);

      if (this.recorder && this.playTime > this.recorder.duration) {
        this.handleStopPlay();
      }
    },

    handleStopPlay() {
      if (!this.recorder) return;

      this.recorder.stopPlay(); // 停止播放
      // 播放时长
      this.playTime = this.recorder.getPlayTime();
      this.timer = null;
      this.icon = "ios-play-outline";
      this.isPausing = true;
    },
    // 重置
    handleDestroy() {
      if (!this.recorder) return;

      const _s = this;
      this.reseting = true;
      /**录音状态，播放状态才能调用停止，否则会销毁失败**/
      this.cording && this.stopLy();
      !this.isPausing && this.handleStopPlay();
      /*销毁之后才可重新录音*/
      this.recorder.destroy().finally(() => {
        _s.recorder = null;
        window.setTimeout(() => _s.reseting = false, 2000);
      });
    },
    broadcastOrStop() {
      if (!this.recorder) return;
      // 开始播放
      if (this.isPausing) {
        // 播放录音
        if (this.recorder == null || this.recorder.duration === 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: langMap.pleaseRecordFirst[this.lang]
          });
          return;
        }
        
        this.handlePlay(); //播放
      } else {
        this.handleStopPlay(); //停止
      }
    },
    stopLy() {
      if (!this.recorder) return;

      this.recorder.stop(); // 停止录音
      this.cording = false;
    },
    // 开始录音
    startLy() {
      let _this = this;
      this.cording = true;
      if (!this.recorder) {
        this.recorder = new Recorder({
          sampleBits: 8,
          sampleRate: 8000,
          numChannels: 1
        })
      }
      Recorder.getPermission().then(
        () => {
          console.log("开始录音");
          this.recorder.start(); // 开始录音
        },
        error => {
          // _this.$message({
          //   message: langMap.allowMicrophone[this.lang],
          //   type: "info"
          // });
          _this.$Notice.info({
            title: langMap.tip[this.lang],
            desc: langMap.allowMicrophone[this.lang]
          });
          _this.cording = false;
          console.log(`${error.name} : ${error.message}`);
        }
      );
    },
    getInfo(id) {
      api.getData("robot-server/robot/get/" + id, this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.currentRobot = res.data;
        }
      });
    },
    closeModal() {
      this.closeAction = true;
      setTimeout(() => {
        this.showImg = false;
        this.closeAction = false;
      }, 300);
    },
    formatTime(t) {
      if (!t) {
        return "";
      }
      return timeUtil.formatTime(t);
    },
    ignore() {
      this.sentimentOperate(4, "", langMap.confirmIgnoreAlert[this.lang])
    },
    handler() {
      this.sentimentOperate(6, "", langMap.confirmHandleAlert[this.lang])
    },
    sentimentOperate(ret, item, content) {
      console.log(23245)
      this.$Modal.confirm({
        title: langMap.systemTip[this.lang],
        content: content,
        onOk: () => {
          this.$Spin.show();
          let d = {
            timestamp: this.robot.time.timestamp,
            ret: ret,
            item: item
          };
          api
            .postData("notice-server/cmd/sentiment", { robotId: this.robot.id,code:this.currentRobot.code, data: d }, this)
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.tip[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.success[this.lang],
                  desc: res.message
                });
              }
              this.$Spin.hide();
            });
        }
      });
    },
    
    // 行为拒止相关方法
    openBehaviorProhibitionModal() {
      this.behaviorProhibitionData = {
          msg: this.robot.time.msg || '',
          img: this.robot.time.img || '',
          x:data.x,
          y:data.y,
          z:data.z,
          targetList: this.robot.time.targetList || []
        };
        
        this.currentBehaviorProhibitionData = {
          code: this.robot.time.code,
          timestamp: this.robot.time.timestamp
        };
        
        this.behaviorProhibitionModalVisible = true;
    },
    
    // 行为拒止成功回调
    onBehaviorProhibitionSuccess(res) {
      // 可以在这里添加成功后的逾辑
      console.log('行为拒止成功:', res);
    },
    
    // 行为拒止错误回调
    onBehaviorProhibitionError(error) {
      console.error('行为拒止错误:', error);
    },
    
    // 行为拒止取消回调
    onBehaviorProhibitionCancel() {
      this.currentBehaviorProhibitionData = null;
      this.behaviorProhibitionData = {};
    },
    
    // 打开音频播放弹窗
    openAudioPlayerModal() {
      if (!this.currentRobot || !this.currentRobot.id) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.robotNotFound ? langMap.robotNotFound[this.lang] : '未找到机器人信息'
        });
        return;
      }
      
      // 设置机器人信息
      this.audioPlayerRobotInfo = {
        id: this.currentRobot.id,
        name: this.currentRobot.name,
        serialNumber: this.currentRobot.code,
        avatar: this.currentRobot.avatar || require('@/assets/images/voice/Robot-icon.png')
      };
      this.audioPlayerModalVisible = true;
    },
    
    // 关闭音频播放弹窗
    closeAudioPlayerModal() {
      this.audioPlayerModalVisible = false;
      this.audioPlayerRobotInfo = {};
    },
    
    // 打开语音对讲弹窗
    openIntercomModal() {
      if (!this.currentRobot || !this.currentRobot.id) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.robotNotFound ? langMap.robotNotFound[this.lang] : '未找到机器人信息'
        });
        return;
      }
      
      // 设置机器人信息
      this.intercomRobotInfo = {
        id: this.currentRobot.id,
        name: this.currentRobot.name,
        serialNumber: this.currentRobot.code,
        avatar: this.currentRobot.avatar || require('@/assets/images/voice/Robot-icon.png')
      };
      this.intercomModalVisible = true;
    },
    
    // 关闭语音对讲弹窗
    closeIntercomModal() {
      this.intercomModalVisible = false;
      this.intercomRobotInfo = {};
    },

  },
  mounted() {
    this.getInfo(this.robot.id);
  },
  updated() {
    // 需要滚动的元素都滚动到最底部
    this.$nextTick(() => {
      const el = this.$refs.dataRef;
      ['move--scroll', 'warn--scroll'].forEach(name => {
        const cel = el.getElementsByClassName(name)[0];
        // const lis = cel.getElementsByTagName('li');
        // lis[lis.length - 1].scrollIntoView();
        cel.scrollTop = 3000 + scrollCount * 100;
        scrollCount++;
      })
    });
  },
  beforeDestory() {
    window.clearInterval(this.timer);
  }
};
</script>
<style lang="less" scoped>
.data-item-box--inner {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #030813;
  position: relative;
  overflow: hidden;

  /* 添加背景网格效果 */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      linear-gradient(rgba(0, 30, 60, 0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0, 30, 60, 0.05) 1px, transparent 1px);
    background-size: 20px 20px;
    z-index: 0;
    pointer-events: none;
  }

  /* 添加发光边框效果 */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid rgba(32, 194, 255, 0.2);
    box-shadow: inset 0 0 15px rgba(32, 194, 255, 0.1);
    pointer-events: none;
    z-index: 1;
  }

  .scrollbar-g::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background: rgba(13, 25, 40, 0.6);
  }

  .scrollbar-g::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    background: rgba(32, 194, 255, 0.4);
    border-radius: 3px;
  }
  
  .scrollbar-g::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
}

.header-box {
  padding: 15px;
  margin: 0;
  color: #dddddd;
  position: relative;
  background: linear-gradient(90deg, rgba(13, 25, 40, 0.9), rgba(13, 25, 40, 0.6));
  border-bottom: 1px solid rgba(32, 194, 255, 0.3);
  display: flex;
  align-items: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  
  /* 添加标题装饰元素 - 改为左侧边框，不再使用伪类 */
  border-left: 4px solid;
  border-image: linear-gradient(to bottom, #20c2ff, #0066cc) 1;

  span {
    color: #20c2ff;
    font-weight: 500;
    font-size: 16px;
    text-shadow: 0 0 10px rgba(32, 194, 255, 0.5);
    letter-spacing: 1px;
    padding-left: 10px;
    border-left: 2px solid #20c2ff;
    display: inline-block;
    position: relative;
    margin-right: 20px; /* 增加右侧空间，避免与指示点重叠 */
    
    /* 添加指示点，改为右侧定位 */
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: -25px; /* 增加距离，避免重叠 */
      width: 8px;
      height: 8px;
      background: #20c2ff;
      border-radius: 50%;
      transform: translateY(-50%);
      box-shadow: 0 0 10px 2px rgba(32, 194, 255, 0.8);
      animation: pulse 2s infinite;
    }
  }
}

@keyframes pulse {
  0% {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
  50% {
    opacity: 0.5;
    transform: translateY(-50%) scale(0.8);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
}

.data-var-box {
  flex: 1;
  list-style: none;
  list-style-type: none;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px;
  overflow: hidden;
  position: relative;
  z-index: 2;
  gap: 10px;
  
  .card-el {
    background: rgba(13, 25, 40, 0.8);
    border: 1px solid rgba(32, 194, 255, 0.3);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3), inset 0 0 10px rgba(32, 194, 255, 0.1);
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
    
    /* 添加发光角效果 */
    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 20px;
      height: 20px;
      border-color: rgba(32, 194, 255, 0.6);
      z-index: 5;
    }
    
    &::before {
      top: 0;
      left: 0;
      border-top: 2px solid;
      border-left: 2px solid;
    }
    
    &::after {
      bottom: 0;
      right: 0;
      border-bottom: 2px solid;
      border-right: 2px solid;
    }
    
    &:hover {
      box-shadow: 0 0 30px rgba(0, 0, 0, 0.4), inset 0 0 15px rgba(32, 194, 255, 0.2);
      border-color: rgba(32, 194, 255, 0.5);
    }
    
    /deep/.ivu-card-body {
      height: 100%;
      padding: 0px !important;
    }
  }

  .ul-box {
    list-style: none;
    list-style-type: none;
    height: 100%;
    background-color: transparent;
    overflow-y: auto;
    color: #20c2ff;
    font-size: 14px;
    padding: 10px;
    overflow-anchor: auto;
    scroll-behavior: smooth;
    font-family: 'Courier New', monospace;
    position: relative;

    .ul-item {
      align-items: center;
      margin-bottom: 6px;
      padding: 6px;
      border-radius: 3px;
      position: relative;
      transition: all 0.2s ease;
      
      /* 添加背景扫描线效果 */
      background: linear-gradient(
        to bottom,
        rgba(32, 194, 255, 0.05) 0%,
        rgba(32, 194, 255, 0.02) 50%,
        rgba(32, 194, 255, 0.05) 100%
      );
      
      &:hover {
        background: rgba(32, 194, 255, 0.1);
        box-shadow: 0 0 10px rgba(32, 194, 255, 0.2);
      }
      
      /* 添加左侧标记 */
      &::before {
        content: '';
        position: absolute;
        left: -2px;
        top: 0;
        width: 2px;
        height: 100%;
        background: linear-gradient(to bottom, transparent, #20c2ff, transparent);
        opacity: 0;
        transition: opacity 0.3s ease;
      }
      
      &:hover::before {
        opacity: 1;
      }
    }

    .item-label {
      color: #8aeeff;
      display: inline-block;
      min-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 10px;
      font-weight: 500;
      text-shadow: 0 0 5px rgba(138, 238, 255, 0.5);
    }
    
    .item-value {
      color: #fff;
      text-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
    }

    li {
      list-style: none;
      list-style-type: none;
    }
  }

  /**左侧盒子**/
  .move-data-box {
    width: 42%;
    position: relative;
    
    .move-title {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      padding: 5px 10px;
      background: rgba(13, 25, 40, 0.9);
      color: #20c2ff;
      font-size: 12px;
      letter-spacing: 1px;
      border-bottom: 1px solid rgba(32, 194, 255, 0.3);
      text-align: center;
      z-index: 10;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 26px;
      box-sizing: border-box;
    }
    
    .move--scroll {
      padding-top: 30px !important;
      height: ~"calc(100% - 26px)";
      margin-top: 26px;
    }
  }

  /**右侧盒子**/
  .data-right-box {
    height: 100%;
    width: 57%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;

    .right-top-box {
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: stretch;
    }

    .right-bottom-box {
      height: 325px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: stretch;
      gap: 10px;
    }
  }

  /**状态模块**/
  .state-data-box {
    width: 100%;
    height: 100%;
    font-size: 12px;
    position: relative;
    
    .status-title {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      padding: 5px 10px;
      background: rgba(13, 25, 40, 0.9);
      color: #20c2ff;
      font-size: 12px;
      letter-spacing: 1px;
      border-bottom: 1px solid rgba(32, 194, 255, 0.3);
      text-align: center;
      z-index: 10;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 26px;
      box-sizing: border-box;
    }
    
    .state-item {
      white-space: normal;
      word-wrap: break-word;
      word-break: break-all;
      line-height: 18px;
      padding-bottom: 8px;
      display: flex;
      justify-content: space-between;
    }
    
    .ul-box {
      padding-top: 30px !important;
      height: ~"calc(100% - 26px)";
      margin-top: 26px;
    }

    .item-value {
      white-space: normal;
      vertical-align: 18%;
    }
  }

  .big-size{
    font-size: 16px;
    padding: 35px 20px 0 30px !important;
  }
  
  /**报警模块**/
  .warn-data-box {
    width: 42%;
    position: relative;
    
    .warn-title {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      padding: 5px 10px;
      background: rgba(13, 25, 40, 0.9);
      color: #ff3c3c;
      font-size: 12px;
      letter-spacing: 1px;
      border-bottom: 1px solid rgba(255, 60, 60, 0.3);
      text-align: center;
      z-index: 10;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 26px;
      box-sizing: border-box;
    }
    
    .warn--scroll {
      padding-top: 30px !important;
      height: ~"calc(100% - 26px)";
      margin-top: 26px;
    }
    
    .warn-item {
      border-left: 3px solid rgba(255, 60, 60, 0.5);
      padding-left: 10px;
      background: rgba(255, 60, 60, 0.05);
    }
  }

  /**时间模块**/
  .time-data-box {
    width: 56.5%;
    background-color: rgba(13, 25, 40, 0.8);
    position: relative;
    
    .camera-title {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      padding: 5px 10px;
      background: rgba(13, 25, 40, 0.9);
      color: #20c2ff;
      font-size: 12px;
      letter-spacing: 1px;
      border-bottom: 1px solid rgba(32, 194, 255, 0.3);
      text-align: center;
      z-index: 10;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 26px;
      box-sizing: border-box;
    }
  }

  .time-text {
    padding: 10px 15px;
    font-size: 12px;
    color: #20c2ff;
    min-width: 130px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .text-content {
    height: 30px;
    text-shadow: 0 0 5px rgba(32, 194, 255, 0.5);
    font-family: 'Courier New', monospace;
    letter-spacing: 1px;
  }

  .time-inner-box {
    height: 100%;
    padding: 35px 5px 5px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    
    .inner-head {
      max-width: 300px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }

  .time-img-box {
    width: 150px;
    height: 150px;
    overflow: hidden;
    border: 1px solid rgba(32, 194, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.5), inset 0 0 5px rgba(32, 194, 255, 0.3);
    position: relative;
    
    /* 添加扫描线效果 */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(to bottom, transparent, rgba(32, 194, 255, 0.1), transparent);
      background-size: 100% 10px;
      pointer-events: none;
      animation: scanline 2s linear infinite;
      z-index: 5;
    }
    
    /* 添加视频框角效果 */
    &::after {
      content: '';
      position: absolute;
      top: 5px;
      right: 5px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #ff3c3c;
      box-shadow: 0 0 5px rgba(255, 60, 60, 0.8);
      animation: blink 1.5s ease infinite;
    }

    img {
      width: 100%;
      height: auto;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:hover {
        filter: brightness(1.2) contrast(1.1);
      }
    }
  }

  @keyframes scanline {
    0% {
      transform: translateY(-100%);
    }
    100% {
      transform: translateY(100%);
    }
  }
  
  @keyframes blink {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }

  .button-group {
    max-width: 300px;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;

    /deep/.ivu-btn {
      margin-right: 5px;
      margin-bottom: 5px;
      background: rgba(13, 25, 40, 0.8);
      border: 1px solid rgba(32, 194, 255, 0.5);
      color: #20c2ff;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
      
      /* 添加按钮悬停效果 */
      &:hover {
        background: rgba(32, 194, 255, 0.2);
        box-shadow: 0 0 10px rgba(32, 194, 255, 0.5);
      }
      
      /* 添加按钮点击效果 */
      &:active {
        transform: scale(0.98);
      }
      
      /* 添加按钮发光边框 */
      &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        border: 2px solid rgba(32, 194, 255, 0);
        transition: all 0.3s ease;
      }
      
      &:hover::before {
        border-color: rgba(32, 194, 255, 0.5);
        box-shadow: 0 0 10px rgba(32, 194, 255, 0.3);
      }
    }

    /deep/.ivu-btn.disabled {
      color: rgba(32, 194, 255, 0.3) !important;
      border-color: rgba(32, 194, 255, 0.2);
      background: rgba(13, 25, 40, 0.4);
    }
    
    /* 特殊按钮样式 */
    /deep/.ivu-btn[type="primary"] {
      background: rgba(32, 194, 255, 0.2);
      border-color: rgba(32, 194, 255, 0.6);
      
      &:hover {
        background: rgba(32, 194, 255, 0.3);
      }
    }
    
    /deep/.ivu-btn[type="warning"] {
      background: rgba(255, 153, 0, 0.2);
      border-color: rgba(255, 153, 0, 0.6);
      color: #ff9900;
      
      &:hover {
        background: rgba(255, 153, 0, 0.3);
        box-shadow: 0 0 10px rgba(255, 153, 0, 0.5);
      }
      
      &:hover::before {
        border-color: rgba(255, 153, 0, 0.5);
      }
    }
    
    /deep/.ivu-btn[type="error"] {
      background: rgba(255, 60, 60, 0.2);
      border-color: rgba(255, 60, 60, 0.6);
      color: #ff3c3c;
      
      &:hover {
        background: rgba(255, 60, 60, 0.3);
        box-shadow: 0 0 10px rgba(255, 60, 60, 0.5);
      }
      
      &:hover::before {
        border-color: rgba(255, 60, 60, 0.5);
      }
    }
  }
}

.empty-data-box {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    position: absolute;
    display: block;
    text-align: center;
    color: rgba(32, 194, 255, 0.5);
    font-size: 14px;
    top: 49%;
    width: 100%;
    font-family: 'Courier New', monospace;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
}

/* 弹框样式 */
/deep/.ivu-modal-content {
  background: rgba(13, 25, 40, 0.95);
  border: 1px solid rgba(32, 194, 255, 0.3);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5), 0 0 15px rgba(32, 194, 255, 0.2);
}

/* 新按钮的特殊样式 */
.button-group {
  /* 语音喊话按钮 */
  /deep/.intercom-btn {
    background: linear-gradient(135deg, rgba(51, 102, 255, 0.2), rgba(51, 102, 255, 0.1));
    border: 1px solid rgba(51, 102, 255, 0.6);
    color: #3366ff;
    position: relative;
    overflow: hidden;
    font-weight: 600;
    
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
      transition: left 0.5s;
    }
    
    &:hover {
      background: linear-gradient(135deg, rgba(51, 102, 255, 0.3), rgba(51, 102, 255, 0.2));
      box-shadow: 0 0 15px rgba(51, 102, 255, 0.5), inset 0 0 5px rgba(51, 102, 255, 0.3);
      transform: translateY(-2px);
      
      &::after {
        left: 100%;
      }
    }
    
    .ivu-icon {
      animation: intercom-icon-pulse 2s ease-in-out infinite;
    }
  }
  
  /* 音频播放按钮 */
  /deep/.audio-play-btn {
    background: linear-gradient(135deg, rgba(25, 190, 107, 0.2), rgba(25, 190, 107, 0.1));
    border: 1px solid rgba(25, 190, 107, 0.6);
    color: #19be6b;
    position: relative;
    overflow: hidden;
    font-weight: 600;
    
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
      transition: left 0.5s;
    }
    
    &:hover {
      background: linear-gradient(135deg, rgba(25, 190, 107, 0.3), rgba(25, 190, 107, 0.2));
      box-shadow: 0 0 15px rgba(25, 190, 107, 0.5), inset 0 0 5px rgba(25, 190, 107, 0.3);
      transform: translateY(-2px);
      
      &::after {
        left: 100%;
      }
    }
    
    .ivu-icon {
      animation: audio-icon-pulse 1.8s ease-in-out infinite;
    }
  }
  
  /* 行为拒止按钮 */
  /deep/.behavior-btn {
    background: linear-gradient(135deg, rgba(255, 153, 0, 0.2), rgba(255, 153, 0, 0.1));
    border: 1px solid rgba(255, 153, 0, 0.6);
    color: #ff9900;
    position: relative;
    overflow: hidden;
    font-weight: 600;
    
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
      transition: left 0.5s;
    }
    
    &:hover {
      background: linear-gradient(135deg, rgba(255, 153, 0, 0.3), rgba(255, 153, 0, 0.2));
      box-shadow: 0 0 15px rgba(255, 153, 0, 0.5), inset 0 0 5px rgba(255, 153, 0, 0.3);
      transform: translateY(-2px);
      
      &::after {
        left: 100%;
      }
    }
    
    .ivu-icon {
      animation: locate-pulse 2s ease-in-out infinite;
    }
  }
  
  /* 停止行为拒止按钮 */
  /deep/.stop-behavior-btn {
    background: linear-gradient(135deg, rgba(108, 240, 245, 0.2), rgba(108, 240, 245, 0.1));
    border: 1px solid rgba(108, 240, 245, 0.6);
    color: #6cf0f5;
    font-weight: 600;
    
    &:hover {
      background: linear-gradient(135deg, rgba(108, 240, 245, 0.3), rgba(108, 240, 245, 0.2));
      box-shadow: 0 0 15px rgba(108, 240, 245, 0.5), inset 0 0 5px rgba(108, 240, 245, 0.3);
      transform: translateY(-2px);
    }
    
    .ivu-icon {
      animation: stop-pulse 1.5s ease-in-out infinite;
    }
  }
  
  /* 完成处置按钮 */
  /deep/.complete-btn {
    background: linear-gradient(135deg, rgba(76, 175, 80, 0.2), rgba(76, 175, 80, 0.1));
    border: 1px solid rgba(76, 175, 80, 0.6);
    color: #4caf50;
    font-weight: 600;
    
    &:hover {
      background: linear-gradient(135deg, rgba(76, 175, 80, 0.3), rgba(76, 175, 80, 0.2));
      box-shadow: 0 0 15px rgba(76, 175, 80, 0.5), inset 0 0 5px rgba(76, 175, 80, 0.3);
      transform: translateY(-2px);
    }
    
    .ivu-icon {
      animation: complete-pulse 2s ease-in-out infinite;
    }
  }
}

/* 按钮图标动画 */
@keyframes intercom-icon-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.15);
    opacity: 0.85;
  }
}

@keyframes audio-icon-pulse {
  0%, 100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  25% {
    transform: scale(1.1) rotate(-5deg);
  }
  75% {
    transform: scale(1.1) rotate(5deg);
  }
}

@keyframes locate-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

@keyframes stop-pulse {
  0%, 100% {
    transform: scale(1) rotate(0deg);
  }
  50% {
    transform: scale(1.05) rotate(5deg);
  }
}

@keyframes complete-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
}

/deep/.ivu-modal-header {
  background: rgba(13, 25, 40, 1);
  border-bottom: 1px solid rgba(32, 194, 255, 0.3);
  padding: 10px 16px;
}

/deep/.ivu-modal-header-inner {
  color: #20c2ff;
  font-size: 16px;
  letter-spacing: 1px;
}

/deep/.ivu-modal-close {
  color: rgba(32, 194, 255, 0.7);
  
  &:hover {
    color: #20c2ff;
  }
}

/deep/.ivu-modal-body {
  padding: 16px;
}

/deep/.ivu-modal-footer {
  border-top: 1px solid rgba(32, 194, 255, 0.3);
  padding: 10px 16px;
}

.modal-box {
  overflow: auto;
  max-height: 700px;
  
  img {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: auto;
    border: 1px solid rgba(32, 194, 255, 0.3);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  }
}

/* 标签样式 */
/deep/.ivu-tag {
  background: transparent;
  margin-right: 5px;
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 3px;
  font-size: 12px;
  
  &.ivu-tag-red {
    color: #ff3c3c;
    border: 1px solid rgba(255, 60, 60, 0.5);
    background: rgba(255, 60, 60, 0.1);
  }
  
  &.ivu-tag-yellow {
    color: #ffcc00;
    border: 1px solid rgba(255, 204, 0, 0.5);
    background: rgba(255, 204, 0, 0.1);
  }
}

/* Poptip样式 */
/deep/.ivu-poptip-popper {
  background: rgba(13, 25, 40, 0.95);
  border: 1px solid rgba(32, 194, 255, 0.3);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5), 0 0 15px rgba(32, 194, 255, 0.2);
}

/deep/.ivu-poptip-title {
  color: #20c2ff;
  border-bottom: 1px solid rgba(32, 194, 255, 0.3);
}

/deep/.ivu-poptip-body {
  color: #ffffff;
}

/deep/.ivu-poptip-arrow::after {
  border-top-color: rgba(13, 25, 40, 0.95) !important;
  border-bottom-color: rgba(13, 25, 40, 0.95) !important;
}
</style>
